import { environment } from '../environments/environment';
import { StatementMethod } from './shared/enums/statementMethod.enum';


export const AUTHORIZATION_PARAMETER = 'authorization';
export const JWT_TOKEN_STORAGE_KEY = 'jwt_key';

// Rest API hosts
export const csamService = environment.API_SERVER_HOST;
export const ocdService = environment.OCD_SERVER_HOST;
export const csLegacyUrl = environment.OLD_CS_AM_URL;

export const serverDev = 'https://' + csamService;
export const serverOCD = 'https://' + ocdService;
export const serverLocal = 'http://localhost:8080/cs-am-service';
export const apiURL = '/rest';
export const paylocEndpoint = '/public/v1/payloc/';
export const paylocSearchEndpoint = 'search';
export const defaultSearchDelay = 1500;
export const whitelist = [csamService];
export const customerEndpoint = '/public/v1/customer/';
export const COUNTRIES_WITH_STATES = ["US", "CA", "AU"];
export const STATEMENT_METHODS_WITH_EMAIL = [StatementMethod.WORD_DOC_EMAIL, StatementMethod.EMS_WORD_DOC_EMAIL, StatementMethod.EMS_EMAIL, StatementMethod.EMS_EMAIL_AND_PAPER_STATEMENT, StatementMethod.PROP_SUM_EMS_STATEMENT_EMAIL, StatementMethod.AGENCY_SUM_EMS_STATEMENT_EMAIL, StatementMethod.EMS_WITH_TRANS_FEES_EMAIL, StatementMethod.EMS_WITH_COMM_REDUCED_EMAIL, StatementMethod.TBG_EMAIL];
export const COUNTRIES_WITH_REQUIRED_INFO = ["US", "CA"];
export const YES = 'Y';

